/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Invoice_Misa_Template_LoadedInputs */

const vi_invoice_misa_template_loaded = /** @type {(inputs: Invoice_Misa_Template_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã tải ${i?.count} mẫu đang hoạt động từ MISA.`)
};

/**

* @param {Invoice_Misa_Template_LoadedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_misa_template_loaded = /** @type {((inputs: Invoice_Misa_Template_LoadedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Misa_Template_LoadedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_misa_template_loaded(inputs)
});